// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32WIb","textarea":"styles_textarea__2Bn-Z"};